var $1f679bbb79879af2$exports = {};
$1f679bbb79879af2$exports = {
    "loading": `U\u{10D}itavam...`,
    "placeholder": `Odaberite\u{2026}`
};


export {$1f679bbb79879af2$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
